import { createContext } from 'react'
import { initialData, InitialData } from '../config/load'

const StorageContext = createContext<InitialData>(initialData)

export default StorageContext
